import { TrackerEvent } from '../../../tracker-event';
import {
  getPayloadForCategoryView,
  getPayloadForCourseView,
  getPayloadForSPA,
  getPayloadForTransactionPayment,
} from '../../support';

export const events = ({ tracker, condition }) => {
  const gtag = tracker;
  const { userId, optimizeId, id } = condition;

  return {
    [TrackerEvent.PAGE_VIEW](data) {
      if (data) {
        gtag('config', id, {
          user_id: userId,
          optimize_id: optimizeId,
          page_path: data.pagePath,
        });
      }
    },
    [TrackerEvent.USER_SIGNUP]({ userId }) {
      const type = 'event';
      const eventName = 'sign_up';
      const payload = { user_id: userId };

      gtag(type, eventName, payload);
    },
    [TrackerEvent.USER_LOGIN]({ userId }) {
      const type = 'event';
      const eventName = 'login';
      const payload = { user_id: userId };

      gtag(type, eventName, payload);
    },
    [TrackerEvent.FORMAT_VIEW]() {},
    [TrackerEvent.CATEGORY_VIEW](category) {
      if (category) {
        const type = 'event';
        const eventName = 'view_item_list';
        const payload = getPayloadForCategoryView({ category, userId });

        gtag(type, eventName, payload);
      }
    },
    [TrackerEvent.COURSE_VIEW](course) {
      if (course) {
        const type = 'event';
        const eventName = 'view_item';
        const payload = getPayloadForCourseView({ course, userId });

        gtag(type, eventName, payload);
      }
    },
    [TrackerEvent.ENROLLMENT_VIEW](data) {
      if (data) {
        const type = 'event';
        const eventName = 'initiate_enrollment';
        const payload = getPayloadForSPA({ data, userId });

        gtag(type, eventName, payload);
      }
    },
    [TrackerEvent.ENROLLMENT_PENDING](data) {
      if (data) {
        const type = 'event';
        const eventName = 'generate_lead';
        const payload = getPayloadForSPA({ data, userId });
        payload.edu_pagetype = 'lead';

        gtag(type, eventName, payload);
      }
    },
    [TrackerEvent.TRANSACTION_ORDER](data) {
      if (data) {
        const type = 'event';
        const eventName = 'begin_checkout';
        const payload = getPayloadForSPA({ data, userId });

        gtag(type, eventName, payload);
      }
    },
    [TrackerEvent.TRANSACTION_PAYMENT](data) {
      if (data) {
        const type = 'event';
        const eventName = 'purchase';
        const payload = getPayloadForTransactionPayment({ data, userId });

        gtag(type, eventName, payload);
      }
    },
    [TrackerEvent.COMMON](data) {
      const type = 'event';
      const { eventName, payload } = data;

      gtag(type, eventName, payload);
    },
  };
};
